// @ts-nocheck
import React from 'react';
import { InfoIcon, CheckIcon, AlertTriangleIcon, AlertCircleIcon, XIcon } from './icons';

const TONES = {
  info:    { ic: InfoIcon,           cls: 'mov-alert-info',    iconBg: 'bg-mov-paper',       iconFg: 'text-mov-ink-soft' },
  success: { ic: CheckIcon,          cls: 'mov-alert-success', iconBg: 'bg-mov-green-soft',  iconFg: 'text-mov-green-ink' },
  warn:    { ic: AlertTriangleIcon,  cls: 'mov-alert-warn',    iconBg: 'bg-mov-warn-soft',   iconFg: 'text-mov-warn-ink' },
  danger:  { ic: AlertCircleIcon,    cls: 'mov-alert-danger',  iconBg: 'bg-mov-danger-soft', iconFg: 'text-mov-danger-ink' },
};

const Alert = ({ tone = 'info', title, children, onClose, className = '' }) => {
  const t = TONES[tone] || TONES.info;
  const Ic = t.ic;
  return (
    <div className={`mov-alert ${t.cls} flex items-start gap-3 text-[13px] ${className}`}>
      <span
        aria-hidden="true"
        className={`grid place-items-center shrink-0 w-[22px] h-[22px] rounded-full ${t.iconBg} ${t.iconFg}`}
      >
        <Ic size={12} />
      </span>
      <div className="flex-1 min-w-0">
        {title && <b className="block mb-0.5">{title}</b>}
        {children && <small className="block text-mov-ink-soft">{children}</small>}
      </div>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          aria-label="Dismiss"
          className="bg-transparent border-0 text-mov-ink-mute hover:text-mov-ink cursor-pointer"
        >
          <XIcon size={14} />
        </button>
      )}
    </div>
  );
};

export default Alert;
